import React from "react";
import { MissionType } from "@/types";
import Link from "next/link";
import { useMission } from "@/hooks";
import { Check } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button, Badge } from "@oreme/ui";

type MissionTableRowProps = {
  mission: MissionType;
  active?: boolean;
};

function MissionTableRow({
  mission,
  active = false,
}: Readonly<MissionTableRowProps>) {
  const t = useTranslations("mission.MissionTableRow");
  const { locateMission } = useMission();

  const handleClick = () => {
    locateMission(mission);
  };

  return (
    <tr
      className="m-0 border-t p-0 text-xs hover:cursor-default hover:bg-accent/40 data-[state='active']:bg-primary data-[state='active']:text-primary-foreground data-[state='active']:cursor-default"
      data-state={active ? "active" : "default"}
    >
      <td className="pl-4 py-2 text-left">
        {active ? (
          <span className="px-2">{mission.mission_num2}</span>
        ) : (
          <Button
            size="xs"
            variant="ghost"
            className="hover:bg-background"
            onClick={handleClick}
            title={t("accessMission")}
          >
            {mission.mission_num2}
          </Button>
        )}
      </td>
      <td className="pl-4 py-2 text-left">
        {mission.countries ? (
          <p className="w-full">{mission.countries.replaceAll(",", ", ")}</p>
        ) : null}
      </td>
      <td className="pl-4 py-2 text-left">
        {mission.responsable1 || mission.responsable2 ? (
          <ul className="list-comma">
            {mission.responsable1 && <li>{mission.responsable1}</li>}
            {mission.responsable2 && <li>{mission.responsable2}</li>}
          </ul>
        ) : null}
      </td>
      <td className="pl-4 py-2 text-right">
        <Badge>{mission.sites_nb}</Badge>
      </td>
      <td className="px-4 py-2 text-center">
        {mission.url ? (
          <Link href={mission.url} target="_blank" title={t("accessData")}>
            <Button size="icon" variant="secondary">
              <Check size={20} />
            </Button>
          </Link>
        ) : null}
      </td>
    </tr>
  );
}

export { MissionTableRow };
